import React from "react";

const CoolAssistantMark = ({ size = 64 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_116_2575)" transform="translate(-11 -9)">
      <circle cx="43" cy="41" r="32" fill="white" />
      <circle
        cx="43"
        cy="41"
        r="32"
        fill="url(#paint0_linear_116_2575)"
        fill-opacity="0.5"
      />
      <path
        d="M62.9945 39.9003C62.9183 42.5326 61.8654 45.0472 60.5354 47.1807C59.2193 49.3281 57.8546 51.2954 56.3376 53.2696C54.8205 55.2162 53.0818 57.2943 50.7474 58.6659C48.4338 60.0513 45.6283 60.5431 42.9752 60.2729C40.3013 60.0097 37.7937 58.8806 35.6948 57.4813C33.5821 56.0682 31.7602 54.5027 30.0492 52.8332C28.3521 51.15 26.8766 49.2311 25.6713 47.0768C24.4729 44.9225 23.5586 42.498 23.1914 39.9073C22.7966 37.3235 23.0044 34.5665 23.8911 31.9965C24.1127 31.3592 24.3967 30.7358 24.6738 30.1193C24.9786 29.5097 25.3319 28.9278 25.6852 28.3459C26.0662 27.7849 26.4749 27.2376 26.9113 26.7181C27.3754 26.2263 27.8949 25.7691 28.4075 25.3396C28.9686 24.9447 29.5436 24.5845 30.1324 24.259C30.7558 23.9749 31.3792 23.7117 32.0027 23.4901C32.6538 23.303 33.2842 23.1091 33.9146 22.9636L35.8057 22.6034C38.2856 22.2155 40.5784 21.7721 42.9683 21.6821C45.3443 21.592 47.8034 21.7167 50.2487 22.3402C52.6801 22.9636 55.0422 24.1689 56.9679 25.9076C57.4251 26.3648 57.8892 26.8151 58.3464 27.2861C58.7621 27.7849 59.1846 28.2836 59.5864 28.8031C59.9466 29.3434 60.3137 29.8907 60.6532 30.4518C60.958 31.0337 61.2766 31.6086 61.5537 32.2113C62.6135 34.6288 63.0846 37.3027 62.9876 39.9142L62.9945 39.9003ZM56.2545 39.9003C56.1505 38.1478 55.7626 36.4645 55.153 34.8574C55.0006 34.4556 54.8136 34.0608 54.6543 33.659L54.0447 32.5091L53.3381 31.3939L52.5208 30.3479C51.3639 29.004 50.0339 27.7364 48.4338 26.6973C46.8544 25.6513 44.9494 24.9101 42.9683 24.8201C42.4765 24.8201 41.9777 24.8339 41.4859 24.8547C40.9941 24.917 40.5092 25.014 40.0243 25.1041C39.5463 25.2357 39.0891 25.4366 38.6388 25.6236C38.2024 25.8591 37.7868 26.1431 37.392 26.4271C37.011 26.7458 36.6577 27.1129 36.3252 27.4593C36.0065 27.8403 35.7225 28.249 35.4385 28.6161C35.1753 29.0248 34.9398 29.4335 34.6835 29.7937C34.4549 30.1886 34.2332 30.5695 33.9838 30.909C33.7691 31.283 33.5405 31.6294 33.2911 31.955C33.0833 32.3082 32.8201 32.62 32.5707 32.9525C32.3629 33.3057 32.1274 33.6452 31.8988 33.9846C31.7118 34.3517 31.4901 34.6981 31.2823 35.0583C30.4995 36.5199 29.8484 38.1201 29.4535 39.9003C29.0933 41.6737 29.031 43.6063 29.5089 45.4767C29.973 47.347 30.9636 49.1272 32.349 50.5265C33.7275 51.9396 35.5909 52.8402 37.5097 53.0965C39.4355 53.3666 41.285 53.0965 42.9752 52.8402C44.6862 52.5631 46.2379 52.1959 47.9489 51.9119C49.6391 51.6141 51.5925 51.2261 53.158 50.0901C54.7236 48.9818 55.825 47.25 56.1783 45.3728C56.5246 43.4747 56.3307 41.6321 56.2614 39.9073L56.2545 39.9003Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_116_2575"
        x1="23.7018"
        y1="16.5151"
        x2="71.7513"
        y2="60.2708"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5BC9FF" />
        <stop offset="0.682692" stop-color="#AD7CF1" />
        <stop offset="1" stop-color="#FF2EE4" />
      </linearGradient>
      <clipPath id="clip0_116_2575">
        <rect width="64" height="64" fill="white" transform="translate(11 9)" />
      </clipPath>
    </defs>
  </svg>
);

export default CoolAssistantMark;
